var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align-content":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"2","align-self":"center"}},[_c('media-gallery',{on:{"selected":_vm.onSelect}})],1),_c('v-col',[_c('v-img',{attrs:{"src":_vm.src,"max-width":"150"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }